module.exports = __webpack_public_path__ + "img/cuo.6c22fe56.png";